import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class MenubarService {
  private _http = inject(HttpClient);
  private _baseUrl = environment.baseUrl;

  get() {
    return this._http.get<MenuItem[]>(`${this._baseUrl}/Menu`);
  }

}
